import React, { useState } from 'react';
import { Rate, Button, Carousel, Image } from 'antd';
import './index.css';
import HeaderComponent from '../../components/Header';

const ItemPage = () => {
	const [selectedImageIndex, setSelectedImageIndex] = useState(0);

	const images = [
		'https://5.imimg.com/data5/GM/GI/MY-14628326/new-xps-13-laptop-500x500.png',
		'https://5.imimg.com/data5/SELLER/Default/2022/8/HS/UH/QL/156789997/91wgl3ibnil-sl1500--500x500.jpg',
	];

	return (
		<>
			<HeaderComponent />
			<div className="pro-container">
				<div className="innerdiv">
					<div className="vertical-images">
						{images.map((image, index) => (
							<Image
								key={index}
								src={image}
								alt={`Thumbnail ${index + 1}`}
								preview={false}
								onClick={() => setSelectedImageIndex(index)}
								style={{
									border: selectedImageIndex === index ? '2px solid #33D7DB' : '1px solid #ccc',
								}}
							/>
						))}
					</div>

					<div className="left-div">
						<Carousel
							style={{ width: '100%' }}
							arrows
							afterChange={(currentIndex) => setSelectedImageIndex(currentIndex)}
							ref={(carouselRef) => {
								if (carouselRef && carouselRef.goTo) {
									carouselRef.goTo(selectedImageIndex);
								}
							}}
							dots={false}
							speed={0}
							fade
							infinite
						>
							{images.map((image, index) => (
								<Image
									key={index}
									alt={`Slide ${index + 1}`}
									src={image}
									className="product-image"
									// preview={false}
								/>
							))}
						</Carousel>
						<div className="actions">
							<Button size="large" type="primary" block>
								Buy Now
							</Button>
							<Button size="large" block>
								Add to Cart
							</Button>
						</div>
					</div>

					<div className="right-div">
						<div className="product-details">
							<h1>Dell Latitude 3420</h1>
							<div className="pricing">
								<span>₹71,499.00</span>₹39,999.00
							</div>
							<div style={{ marginTop: '0px' }} className="description">
								Including Taxes
							</div>
							<Rate disabled defaultValue={5} /> <span>(14 reviews)</span>
							<p className="description">
								Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi non erat quam. Vestibulum
								aliquam.
							</p>
							<ul className="description">
								<li>Intel® Core™ i5-11th gen Processor</li>
								<li>16GB RAM</li>
								<li>512GB NVMe SSD Hard disk</li>
								<li>6-8 hours hours, Longer battery life</li>
								<li>14"-inch Display</li>
								<li>HD FaceTime HD camera</li>
								<li>18 months Dell warranty</li>
								<li>Available at Store. Vijayanagar, Bengaluru.</li>
							</ul>
							{/* <div className='desc-heading'>RETURN & REFUND</div>
                            <ul className="description">
                                <li>New Products must be returned to us within seven (07) working days from the date on which you have received the product / must be dispatched to us within seven (07) working days from the date of receipt of the product.</li>

                                <li> Open Box & Pre Owned Products shall be returned to us within Seven (7) working days from the date on which you have received the product and will be accepted only in case of the following :</li>
                                <ul className="description">
                                    <li>Stocks are dead on arrival or have a major technical problem.</li>

                                    <li>The product received is physically damaged.</li>

                                    <li>Product is termed as irreparable by the service center within 30 days of purchase</li>
                                </ul>
                            </ul>

                            <div className='desc-heading'>SHIPPING INFO</div>
                            <ul className="description">
                                <li> Currently shipping across Bengaluru. Free delivery</li>
                                <li>Cash on Delivery Available</li>
                            </ul> */}
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default ItemPage;
